// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  sslCheck: true,
  recaptcha: {
    siteKey: '6Lf0fhspAAAAALKav1YNfwWHkJK_C_3_zmYaiQo7',
    siteKeyV3: '6Lc-SR8pAAAAACZqUhJIqkUWMFhcoDzsgeEuLsZs'
  },
  apiUrl: 'AEJSONServiceDEV/',  // Dev
  apiShopUrl: 'AEJSONShopServiceDEV/'  // Dev
  // apiUrl: 'https://Agenddoc.areon.ua/siebel/v1.0/service/AEJSONService/'  // Test
  // https://Agenddoc.areon.ua/siebel/v1.0/service/AEJSONService/
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
